// Gerenciar conexão (#355): o que cada tipo de conexão permite fazer no modal "Gerenciar".
// Helpers puros (sem React e sem rede). Cada ação tem um `id`; quem monta o modal liga o id ao handler.

const RECONNECT = {
  id: 'reconnect', icon: 'refresh', title: 'Reconectar', label: 'Reconectar',
  desc: 'Refaz o login para renovar a autorização. Não apaga contas nem dados.',
}

const DELETE = {
  id: 'delete', icon: 'trash', title: 'Excluir conexão', label: 'Excluir conexão', danger: true,
  desc: 'Revoga o acesso e remove a conexão. As contas e os dados continuam nos clientes e voltam a coletar quando você vincular as contas a uma nova conexão.',
}

const LINK_ACCOUNTS = {
  id: 'link-accounts', icon: 'users', title: 'Contas e clientes', label: 'Vincular contas',
  desc: 'Escolha quais contas deste login entram no sistema e a qual cliente cada uma pertence. Várias contas podem ficar no mesmo cliente.',
}

// Ações por tipo. `ctx`: { kind: 'google' | 'gcal' | 'meta', product, active, managementEnabled, canManageAds }.
export function manageActions(ctx) {
  const { kind, product, active = true, managementEnabled = false, canManageAds = false } = ctx || {}
  const needsActive = (a) => (active ? a : { ...a, disabled: true, hint: 'Reconecte antes: a conexão está desativada.' })

  if (kind === 'gcal') {
    return [{
      id: 'open-agenda', icon: 'calendar', title: 'Agenda', label: 'Gerenciar na Agenda',
      desc: 'A agenda do Google Calendar é vinculada e desconectada por cliente, na própria Agenda.',
    }]
  }

  if (kind === 'google') return [needsActive(LINK_ACCOUNTS), RECONNECT, DELETE]

  // Meta, por produto.
  if (product === 'facebook') {
    return [{
      id: 'lead-ads', icon: 'leads', title: 'Páginas e Lead Ads', label: 'Configurar Lead Ads',
      desc: 'Vincule Páginas do Facebook a um cliente para que os leads dos formulários entrem no CRM com a campanha de origem.',
    }, RECONNECT, DELETE]
  }
  if (product === 'instagram') {
    return [{
      id: 'info', icon: 'page', title: 'Contas do Instagram', label: null,
      desc: 'O Instagram usa as Páginas do Facebook vinculadas a cada cliente: vincule as Páginas em Facebook > Lead Ads. Pode haver mais de uma conexão de Instagram (um login por conexão); o orgânico lê as Páginas de todas.',
    }, RECONNECT, DELETE]
  }
  if (product === 'messaging') {
    return [{
      id: 'messaging', icon: 'attend', title: 'Instagram Direct e Messenger', label: 'Configurar canais',
      desc: 'Vincule Páginas e contas do Instagram a um cliente para receber e responder as mensagens no Atendimento. A resposta só sai nas 24 horas seguintes à última mensagem do contato.',
    }, RECONNECT, DELETE]
  }
  // Meta Ads
  const actions = [needsActive(LINK_ACCOUNTS)]
  if (canManageAds) {
    actions.push({
      id: 'enable-management', icon: 'chart', title: 'Gestão de anúncios',
      status: managementEnabled ? 'Habilitada' : 'Somente leitura',
      label: managementEnabled ? null : 'Habilitar gestão de anúncios',
      desc: managementEnabled
        ? 'Owner e admin podem pausar, ativar e ajustar o orçamento de campanhas em Meta Ads > Campanhas. Toda alteração fica registrada no histórico.'
        : 'Permite pausar, ativar e ajustar o orçamento de campanhas pelo CRM. Pede uma nova autorização na Meta; a leitura de métricas continua funcionando.',
    })
  }
  actions.push(RECONNECT, DELETE)
  return actions
}

// Texto da confirmação de excluir: o que a exclusão faz e quem é afetado.
export function deleteConfirmation(title, impact) {
  return [
    `Excluir a conexão ${title}?`,
    'O acesso é revogado e a conexão some da lista. As contas e os dados continuam nos clientes.',
    impact,
  ].filter(Boolean).join('\n\n')
}

// Estado que o picker de contas recebe ao ser aberto pelo Gerenciar (mesmo formato do callback do OAuth),
// com a volta para a tela de Conexões.
export const CONNECTIONS_PATH = '/configuracoes/conexoes'

export function googlePickerState(res) {
  return {
    connectionId: res.connection_id, googleEmail: res.google_email,
    customers: res.available_customers || [], returnTo: CONNECTIONS_PATH,
  }
}

export function metaPickerState(res) {
  return {
    connectionId: res.connection_id, metaUserEmail: res.meta_user_email,
    accounts: res.available_accounts || [], returnTo: CONNECTIONS_PATH,
  }
}
